import { render } from "./QRGenerator.vue?vue&type=template&id=26467e9c&scoped=true&ts=true"
import script from "./QRGenerator.vue?vue&type=script&lang=ts"
export * from "./QRGenerator.vue?vue&type=script&lang=ts"

import "./QRGenerator.vue?vue&type=style&index=0&id=26467e9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rogerio\\devel\\pixPrinter\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26467e9c"]])

export default __exports__